import { createQueryClient } from "./createQueryClient"

export const queryClient = createQueryClient()
